import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainLayoutComponent} from './main-layout.component';
import {RouterModule} from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {AlertModule} from '../../dumb/alert/alert.module';
import {SearchInputModule} from '../../dumb/search-input/search-input.module';
import {TooltipPanelModule} from '../../dumb/tooltip-panel/tooltip-panel.module';
import {ButtonModule} from '../../dumb/button/button.module';
import {HeaderComponent} from './header/header.component';
import {NavigationComponent} from './navigation/navigation.component';
import {NavMenuComponent} from './nav-menu/nav-menu.component';
import {TeamNavLinkModule} from './team-nav-link/team-nav-link.module';
import {NavItemModule} from '../../dumb/nav-item/nav-item.module';
import {TranslateModule} from '@ngx-translate/core';
import {NotificationsDrawerModule} from '../../../modules/notifications-drawer/notifications-drawer.module';
import {SearchSiteModule} from '../../../modules/search-site/search-site.module';
import {TopNotificationsModule} from '../top-notifications/top-notifications.module';
import {ToastContainerDirective, ToastrModule} from 'ngx-toastr';
import {WalkThroughModule} from '../../../modules/walkthrough/walkthrough.module';
import {TeamSelectorModule} from '../../dumb/team-selector/team-selector.module';
import {DirectivesModule} from '../../../common/directives/directives.module';
import {MyAccountSettingsComponent} from './header/my-account-settings/my-account-settings.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ExpansionPanelModule} from '../../dumb/expansion-panel/expansion-panel.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDialogModule} from '@angular/material/dialog';
import {ExpansionPanelNavItemModule} from '../../dumb/expansion-panel-nav-item/expansion-panel-nav-item.module';
import {TeamNavLinkGroupFeatureModule} from './team-nav-link-group-feature/team-nav-link-group-feature.module';
import {TooltipPanelWrapperComponent} from '../../dumb/tooltip-panel-wrapper/tooltip-panel-wrapper.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    NavigationComponent,
    NavMenuComponent,
    HeaderComponent,
    MyAccountSettingsComponent,
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatInputModule,
    MatIconModule,
    AlertModule,
    SearchInputModule,
    TooltipPanelModule,
    TranslateModule,
    ButtonModule,
    RouterModule,
    MatSidenavModule,
    TeamNavLinkModule,
    NavItemModule,
    NotificationsDrawerModule,
    SearchSiteModule,
    TopNotificationsModule,
    ToastrModule,
    ToastContainerDirective,
    WalkThroughModule,
    TeamSelectorModule,
    DirectivesModule,
    SharedModule,
    MatTooltipModule,
    ExpansionPanelModule,
    MatExpansionModule,
    MatDialogModule,
    ExpansionPanelNavItemModule,
    TeamNavLinkGroupFeatureModule,
    TooltipPanelWrapperComponent,
  ],
  exports: [],
})
export class MainLayoutModule {}
